/* Ordine Sicurizzato — Broker Ricambi (portato da Carrozzeria Truck)
   Aggiunge da solo il prodotto "Ordine Sicurizzato" (1 pezzo, mai di più) quando
   qualcosa entra nel carrello, anche con "Acquista ora" diretto al checkout.
   Se il cliente lo elimina dal carrello non viene più riproposto per la sessione.
   Se nel carrello resta solo lui, si toglie da solo.
   Config in window.brhOrdineSicurizzato (layout/theme.liquid). */
(function () {
  var cfg = window.brhOrdineSicurizzato;
  if (!cfg || !cfg.variantId || !window.fetch || !window.Promise) return;

  var VID = Number(cfg.variantId);
  var PID = Number(cfg.productId);
  var FLAG = 'brh-os-removed';

  var state = { hasS: null, sQty: 0, sKey: null, others: 0 };
  var correcting = false;
  var addInFlight = null;

  /* reset di servizio: aprire una qualsiasi pagina con ?brh_os_reset=1 azzera la
     memoria "eliminato dal cliente" della sessione (utile per test/assistenza) */
  try {
    if (/[?&]brh_os_reset=/.test(window.location.search)) sessionStorage.removeItem(FLAG);
  } catch (e) { /* niente */ }

  /* origFetch = catena completa al momento del defer (tema + wrapper GA4): per il
     passthrough delle richieste del tema, così gli eventi analytics legittimi vivono.
     rawFetch = fetch nativa catturata nell'head PRIMA del wrapper GA4: per le chiamate
     di servizio nostre, che non devono generare add_to_cart/remove_from_cart fantasma. */
  var origFetch = window.fetch.bind(window);
  var rawFetch = (typeof cfg.nativeFetch === 'function') ? cfg.nativeFetch : origFetch;

  function removedByUser() {
    try { return sessionStorage.getItem(FLAG) === '1'; } catch (e) { return false; }
  }
  /* il suggerimento "riaggiungilo" nei carrelli è pilotato da una classe su <html>,
     che sopravvive ai re-render delle section */
  function syncSuggest() {
    try { document.documentElement.classList.toggle('brh-os-suggest-on', removedByUser()); } catch (e) { /* niente */ }
  }
  function setRemoved() {
    try { sessionStorage.setItem(FLAG, '1'); } catch (e) { /* niente */ }
    syncSuggest();
  }
  function clearRemoved() {
    try { sessionStorage.removeItem(FLAG); } catch (e) { /* niente */ }
    syncSuggest();
  }

  function readCart(cart) {
    var s = null, others = 0;
    var items = cart.items || [];
    items.forEach(function (it) {
      if (it.product_id === PID || it.variant_id === VID) s = it;
      else others += it.quantity;
    });
    state.hasS = !!s;
    state.sQty = s ? s.quantity : 0;
    state.sKey = s ? s.key : null;
    state.others = others;
    /* cart.items è ordinato dal più recente: l'OS deve essere l'ULTIMA riga
       (cioè la più vecchia) per stare in fondo anche al CHECKOUT */
    state.osLast = s ? items[items.length - 1] === s : false;
  }

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  }

  function cartJson() {
    return rawFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---- refresh UI: passa dal pipeline di render nativo del tema (renderContents),
     che gestisce anche is-empty, subtotale, bolla e i <template> lazy di Ignite ---- */
  function refreshUI() {
    try {
      cartJson().then(function (cart) {
        var b = document.querySelector('.header__cart-count');
        if (b) b.textContent = cart.item_count;
      }).catch(function () { /* niente */ });
      var mc = document.getElementById('mini-cart');
      if (mc) {
        var sez = mc.closest('.shopify-section');
        if (sez && sez.id) {
          var secId = sez.id.replace(/^shopify-section-/, '');
          rawFetch('/?sections=' + encodeURIComponent(secId), { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (out) {
              if (!out[secId]) return;
              var doc = new DOMParser().parseFromString(out[secId], 'text/html');
              var fresco = doc.getElementById('mini-cart');
              var attuale = document.getElementById('mini-cart');
              /* MAI replaceWith: Warehouse tiene il riferimento al nodo del load */
              if (fresco && attuale) {
                attuale.innerHTML = fresco.innerHTML;
                if (fresco.hasAttribute('data-item-count')) {
                  attuale.setAttribute('data-item-count', fresco.getAttribute('data-item-count'));
                }
              }
            })
            .catch(function () { /* niente */ });
        }
      }
      /* pagina carrello: form server-side, il modo pulito e' ricaricare */
      if (/^\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    } catch (e) { /* niente */ }
  }

  /* ---- correzioni ----
     rebuildWithOS: ricostruisce il carrello con l'Ordine Sicurizzato come PRIMA
     riga aggiunta (= più vecchia = in fondo, anche al checkout), quantità 1,
     preservando prodotti/quantità/properties. Single-flight: mai due in race. ---- */
  function rebuildWithOS() {
    if (addInFlight) return addInFlight;
    addInFlight = cartJson().then(function (cart) {
      var others = (cart.items || []).filter(function (it) {
        return !(it.product_id === PID || it.variant_id === VID);
      });
      if (!others.length) return null;
      var batch = [{ id: VID, quantity: 1 }];
      others.slice().reverse().forEach(function (it) {   // dal più vecchio al più nuovo
        var e = { id: it.variant_id, quantity: it.quantity };
        if (it.properties && Object.keys(it.properties).length) e.properties = it.properties;
        if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
          e.selling_plan = it.selling_plan_allocation.selling_plan.id;
        }
        batch.push(e);
      });
      var doAdd = function () {
        return rawFetch('/cart/add.js', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ items: batch }) });
      };
      return rawFetch('/cart/clear.js', { method: 'POST', headers: jsonHeaders() })
        .then(doAdd)
        .then(function (r) { return r.ok ? r : doAdd(); })   // un retry: mai lasciare il carrello vuoto
        .then(function (r) {
          if (r.ok) { state.hasS = true; state.sQty = 1; state.osLast = true; }
          return r;
        });
    });
    var clear = function (v) { addInFlight = null; return v; };
    addInFlight = addInFlight.then(clear, function (e) { clear(); throw e; });
    return addInFlight;
  }

  function correctiveSet(qty) {
    if (!state.sKey) return Promise.resolve();
    return rawFetch('/cart/change.js', {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({ id: state.sKey, quantity: qty })
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) readCart(cart); })
      .catch(function () { /* niente */ });
  }

  function applyRulesP() {
    if (correcting || state.hasS === null) return Promise.resolve();
    var finish = function () { correcting = false; refreshUI(); };

    if (state.hasS && state.others === 0) {
      // è rimasto solo l'Ordine Sicurizzato: via
      correcting = true;
      return correctiveSet(0).then(finish, finish);
    }
    if (state.others > 0 && !removedByUser() && (!state.hasS || state.sQty > 1 || !state.osLast)) {
      // manca / è doppio / non è in fondo: ricostruisco il carrello nell'ordine giusto
      correcting = true;
      return rebuildWithOS().then(finish, finish);
    }
    return Promise.resolve();
  }
  function applyRules() { applyRulesP(); }

  /* ---- parsing del body delle /cart/add del tema ---- */
  function parseAddBody(init) {
    var out = { parsed: false, hasS: false, sections: null, sectionsUrl: null };
    if (!init || !init.body) return out;
    var b = init.body;
    try {
      if (typeof b === 'string') {
        var data = JSON.parse(b);
        out.parsed = true;
        if (data.items) {
          out.hasS = data.items.some(function (it) { return Number(it.id) === VID; });
        } else if (data.id) {
          out.hasS = Number(data.id) === VID;
        }
        if (data.sections) out.sections = data.sections;
        if (data.sections_url) out.sectionsUrl = data.sections_url;
      } else if ((window.FormData && b instanceof FormData) || (window.URLSearchParams && b instanceof URLSearchParams)) {
        out.parsed = true;
        out.hasS = Number(b.get('id')) === VID;
        var sec = b.get('sections');
        if (sec) out.sections = String(sec);
        var secUrl = b.get('sections_url');
        if (secUrl) out.sectionsUrl = String(secUrl);
      }
    } catch (e) {
      out.parsed = false;
    }
    return out;
  }

  /* ---- intercettazione add: accoda l'Ordine Sicurizzato prima di rispondere al tema ---- */
  function handleAdd(input, init) {
    return origFetch(input, init).then(function (resp) {
      try {
        if (!resp.ok) return resp;
        var info = parseAddBody(init);
        if (!info.parsed) return resp;             // formato ignoto: non tocco niente

        if (info.hasS) {
          // add diretto del prodotto OS (es. dalla sua pagina): mai più di 1, mai da solo.
          // Attendo la correzione PRIMA di rispondere, così un eventuale redirect a
          // /checkout del buy-now parte a carrello già corretto.
          return cartJson().then(function (c) {
            readCart(c);
            return applyRulesP();
          }).then(function () { return resp; })
            .catch(function () { state.hasS = true; return resp; });
        }

        if (removedByUser()) return resp;

        var sync = (state.hasS === null) ? cartJson().then(readCart) : Promise.resolve();
        return sync.then(function () {
          if (state.hasS && state.sQty === 1 && state.osLast) return resp;   // già a posto
          return rebuildWithOS().then(function (r2) {
            if (!r2 || !r2.ok) return resp;
            if (!info.sections) return resp;       // Acquista ora: si va dritti al checkout
            // le section del tema sono state renderizzate PRIMA della ricostruzione:
            // le rifetcho fresche (righe e line number corretti); preservo SOLO
            // cart-notification-product (il popup deve mostrare il prodotto appena aggiunto)
            var secUrl = (info.sectionsUrl || window.location.pathname) + '?sections=' + encodeURIComponent(info.sections);
            return Promise.all([
              resp.clone().json(),
              rawFetch(secUrl).then(function (r) { return r.json(); })
            ]).then(function (pair) {
              var orig = pair[0], fresh = pair[1];
              if (fresh && orig && orig.sections) {
                Object.keys(fresh).forEach(function (k) {
                  if (k !== 'cart-notification-product' && fresh[k]) {
                    orig.sections[k] = fresh[k];
                  }
                });
              }
              return new Response(JSON.stringify(orig), {
                status: resp.status,
                statusText: resp.statusText,
                headers: { 'Content-Type': 'application/json' }
              });
            }).catch(function () { return resp; });
          }).catch(function () { return resp; });
        }).catch(function () { return resp; });
      } catch (e) {
        return resp;
      }
    });
  }

  /* ---- osservazione di change/update/clear: flag rimozione + regole ----
     Le nostre chiamate di servizio usano rawFetch e non passano di qui:
     osserviamo solo le azioni vere del cliente/tema. ---- */
  function observeMutation(resp) {
    if (!resp.ok) return;
    resp.clone().json().then(function (cart) {
      if (!cart || !cart.items) return;
      var hadS = state.hasS;
      readCart(cart);
      if (hadS === true && !state.hasS && cart.items.length > 0) {
        // il cliente ha tolto l'Ordine Sicurizzato lasciando altri prodotti: rispetto la scelta
        setRemoved();
      }
      applyRules();
    }).catch(function () { /* niente */ });
  }

  var RE_ADD = /\/cart\/add(\.js)?(\?|$)/;
  var RE_MUT = /\/cart\/(change|update|clear)(\.js)?(\?|$)/;

  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    try {
      if (RE_ADD.test(url)) return handleAdd(input, init);
      if (RE_MUT.test(url)) {
        return origFetch(input, init).then(function (resp) {
          observeMutation(resp);
          return resp;
        });
      }
    } catch (e) { /* niente: passa oltre */ }
    return origFetch(input, init);
  };

  /* ---- click su "Aggiungi" del suggerimento: il cliente ci ha ripensato ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-brh-os-restore]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    clearRemoved();
    rebuildWithOS().then(function () { refreshUI(); }, function () { btn.disabled = false; });
  });

  /* ---- allineamento iniziale ---- */
  function initSync() {
    syncSuggest();
    cartJson().then(function (c) {
      readCart(c);
      applyRules();
    }).catch(function () { /* niente */ });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSync);
  } else {
    initSync();
  }
})();
